/*
 * IconButton
 * @module components
 * @flow
 */

import styled, { css } from 'styled-components/macro';
import { palette } from 'styled-theme';

import { StyledButton, type ButtonProps } from '~/components/Button';

export type IconButtonProps = ButtonProps & {};

const backgroundColor = ({ disabled }: IconButtonProps) =>
  palette(disabled ? 2 : 1);
const hoverBackgroundColor = ({ disabled }: IconButtonProps) =>
  !disabled && palette(0);

const styles = css`
  padding: 0;
  width: 91px;
  min-width: 91px;
  height: 91px;
  border-radius: 50%;
  background-color: ${backgroundColor};
  color: ${palette(0, true)};

  &:hover,
  &:focus,
  &:active {
    background-color: ${hoverBackgroundColor};
  }
  &:focus {
    outline: none;
  }
`;

/**
 * IconButton React-component
 * @memberof components
 * @extends Button
 * @example <caption>Simple usage</caption>
 * <IconButton>Button</IconButton>
 * @returns {React.Node<*>} React-component
 */
export const IconButton = styled(StyledButton).attrs(() => ({
  testid: 'iconButton',
  role: 'button',
}))`
  ${styles};
`;

IconButton.defaultProps = {
  palette: 'primary',
  testid: 'iconButton',
};
